export const mockProjects = [
  {
    id: '1',
    name: '"髹漆"与共—清代广作外销漆器',
    keywords: ['漆器', '清代', '"髹漆"与共', '外销漆器'],
    startDate: '2025.11.27',
    endDate: '2026.5.17',
    status: 'active',
    platforms: ['小红书', '微博', '抖音', '视频号'],
    createdAt: '2025-11-26',
  },
  {
    id: '2',
    name: '青铜器文明展',
    keywords: ['青铜器', '商周', '文物', '古代文明'],
    startDate: '2024-02-01',
    endDate: '2024-04-30',
    status: 'active',
    platforms: ['小红书', '微博', '抖音'],
    createdAt: '2024-01-25',
  },
  {
    id: '3',
    name: '现代艺术回顾展',
    keywords: ['现代艺术', '当代', '装置艺术', '互动展览'],
    startDate: '2023-12-01',
    endDate: '2024-01-31',
    status: 'completed',
    platforms: ['小红书', '微博', '视频号'],
    createdAt: '2023-11-20',
  },
];

export const mockStatistics = {
  totalVolume: 45678,
  totalInteraction: 234567,
  positiveRate: 87.5,
  volumeTrend: [
    { date: '01-15', value: 1234 },
    { date: '01-22', value: 2345 },
    { date: '01-29', value: 3456 },
    { date: '02-05', value: 4567 },
    { date: '02-12', value: 5678 },
    { date: '02-19', value: 6789 },
    { date: '02-26', value: 7890 },
  ],
  platformDistribution: [
    { platform: '小红书', count: 18567, percentage: 40.7 },
    { platform: '微博', count: 13701, percentage: 30.0 },
    { platform: '抖音', count: 9135, percentage: 20.0 },
    { platform: '视频号', count: 4275, percentage: 9.3 },
  ],
  contentTypeDistribution: [
    { type: '纯文字', count: 8234, percentage: 18.0, icon: 'ri-file-text-line', color: '#4A8AE9' },
    { type: '纯图片', count: 12456, percentage: 27.3, icon: 'ri-image-line', color: '#10B981' },
    { type: '纯视频', count: 9876, percentage: 21.6, icon: 'ri-video-line', color: '#F59E0B' },
    { type: '文字+图片', count: 11234, percentage: 24.6, icon: 'ri-file-image-line', color: '#8B5CF6' },
    { type: '文字+视频', count: 3878, percentage: 8.5, icon: 'ri-file-video-line', color: '#EC4899' },
  ],
};

export const mockDimensionAnalysis = [
  { dimension: '灯光', score: 8.9, positive: 89, neutral: 8, negative: 3, total: 12456 },
  { dimension: '布景', score: 8.7, positive: 87, neutral: 10, negative: 3, total: 11234 },
  { dimension: '场景', score: 8.5, positive: 85, neutral: 12, negative: 3, total: 10987 },
  { dimension: '说明牌', score: 7.8, positive: 78, neutral: 18, negative: 4, total: 9876 },
  { dimension: '展板', score: 8.2, positive: 82, neutral: 15, negative: 3, total: 8765 },
  { dimension: '氛围', score: 9.1, positive: 91, neutral: 7, negative: 2, total: 13456 },
];

export const mockDimensionAnalysisV2 = {
  overall: {
    name: '展览总体评价',
    score: 8.8,
    positive: 88,
    neutral: 9,
    negative: 3,
    total: 45678,
    insights: [
      { type: 'positive', text: '整体氛围营造出色，沉浸式体验感强烈', count: 3456 },
      { type: 'positive', text: '展品质量高，文化价值突出', count: 2890 },
      { type: 'positive', text: '值得推荐，适合全家参观', count: 2345 },
      { type: 'neutral', text: '周末人流量较大，建议工作日参观', count: 1234 },
      { type: 'negative', text: '部分区域指引不够清晰', count: 456 },
    ]
  },
  design: {
    name: '设计',
    score: 8.6,
    positive: 86,
    neutral: 11,
    negative: 3,
    total: 38456,
    subDimensions: [
      {
        name: '灯光',
        score: 8.9,
        positive: 89,
        neutral: 8,
        negative: 3,
        total: 12456,
        insights: [
          { type: 'positive', text: '灯光设计专业，突出展品细节', count: 2345 },
          { type: 'positive', text: '光影效果营造氛围感强', count: 1890 },
          { type: 'positive', text: '色温控制得当，观感舒适', count: 1567 },
          { type: 'neutral', text: '部分区域光线稍暗', count: 678 },
          { type: 'negative', text: '个别位置存在反光问题', count: 234 },
        ]
      },
      {
        name: '布景',
        score: 8.7,
        positive: 87,
        neutral: 10,
        negative: 3,
        total: 11234,
        insights: [
          { type: 'positive', text: '布景还原度高，细节考究', count: 2123 },
          { type: 'positive', text: '场景设计有创意，视觉冲击力强', count: 1789 },
          { type: 'positive', text: '空间利用合理，动线流畅', count: 1456 },
          { type: 'neutral', text: '部分装饰略显简单', count: 567 },
          { type: 'negative', text: '个别区域布景陈旧', count: 189 },
        ]
      },
      {
        name: '场景',
        score: 8.5,
        positive: 85,
        neutral: 12,
        negative: 3,
        total: 10987,
        insights: [
          { type: 'positive', text: '场景氛围营造到位，代入感强', count: 1987 },
          { type: 'positive', text: '多媒体与实景结合效果好', count: 1678 },
          { type: 'positive', text: '场景转换自然流畅', count: 1345 },
          { type: 'neutral', text: '部分场景互动性不足', count: 789 },
          { type: 'negative', text: '个别场景维护不够及时', count: 234 },
        ]
      },
      {
        name: '说明牌',
        score: 7.8,
        positive: 78,
        neutral: 18,
        negative: 4,
        total: 9876,
        insights: [
          { type: 'positive', text: '内容详实，知识性强', count: 1678 },
          { type: 'positive', text: '语言通俗易懂', count: 1234 },
          { type: 'neutral', text: '字体偏小，阅读不便', count: 1456 },
          { type: 'neutral', text: '部分说明牌位置不佳', count: 987 },
          { type: 'negative', text: '信息量过大，阅读疲劳', count: 345 },
        ]
      },
      {
        name: '展板',
        score: 8.2,
        positive: 82,
        neutral: 15,
        negative: 3,
        total: 8765,
        insights: [
          { type: 'positive', text: '展板设计美观，排版清晰', count: 1567 },
          { type: 'positive', text: '图文并茂，信息传达有效', count: 1345 },
          { type: 'positive', text: '历史脉络梳理清楚', count: 1123 },
          { type: 'neutral', text: '部分展板内容重复', count: 678 },
          { type: 'negative', text: '个别展板更新不及时', count: 234 },
        ]
      },
      {
        name: '氛围',
        score: 9.1,
        positive: 91,
        neutral: 7,
        negative: 2,
        total: 13456,
        insights: [
          { type: 'positive', text: '整体氛围庄重典雅，文化感强', count: 2678 },
          { type: 'positive', text: '音乐与环境完美融合', count: 2345 },
          { type: 'positive', text: '沉浸式体验效果出色', count: 2123 },
          { type: 'neutral', text: '高峰期人多影响体验', count: 567 },
          { type: 'negative', text: '部分区域噪音控制不佳', count: 189 },
        ]
      },
    ]
  },
  interaction: {
    name: '互动',
    score: 7.9,
    positive: 79,
    neutral: 16,
    negative: 5,
    total: 15678,
    insights: [
      { type: 'positive', text: '互动装置新颖有趣，参与度高', count: 2345 },
      { type: 'positive', text: 'AR/VR体验效果好', count: 1890 },
      { type: 'neutral', text: '互动项目排队时间较长', count: 1567 },
      { type: 'neutral', text: '部分设备操作不够直观', count: 1234 },
      { type: 'negative', text: '互动区域数量偏少', count: 678 },
    ]
  },
  activities: {
    name: '配套活动',
    score: 8.3,
    positive: 83,
    neutral: 13,
    negative: 4,
    total: 12345,
    insights: [
      { type: 'positive', text: '专家讲座内容丰富，专业性强', count: 2123 },
      { type: 'positive', text: '工作坊活动形式多样', count: 1789 },
      { type: 'positive', text: '导览服务专业热情', count: 1567 },
      { type: 'neutral', text: '活动时间安排可以更灵活', count: 890 },
      { type: 'negative', text: '部分活动需要额外付费', count: 456 },
    ]
  }
};

export const mockDimensionAnalysisV3 = {
  overview: {
    score: 8.7,
    positive: 87,
    neutral: 10,
    negative: 3,
    total: 45678,
    highlights: [
      { text: '整体氛围营造出色，沉浸式体验感强烈', count: 3456 },
      { text: '展品质量高，文化价值突出', count: 2890 },
      { text: '灯光设计专业，视觉效果震撼', count: 2678 },
      { text: '值得推荐，适合全家参观', count: 2345 },
    ],
    weaknesses: [
      { text: '周末人流量较大，建议工作日参观', count: 1234 },
      { text: '部分区域指引不够清晰', count: 456 },
      { text: '互动区域数量偏少', count: 389 },
    ],
    wordCloud: [
      { word: '震撼', size: 48, color: '#4A8AE9' },
      { word: '精美', size: 42, color: '#5A9EED' },
      { word: '值得', size: 38, color: '#6AAEF1' },
      { word: '推荐', size: 36, color: '#7ABEF5' },
      { word: '氛围', size: 34, color: '#8ACEF9' },
      { word: '灯光', size: 32, color: '#9ADEFD' },
      { word: '布景', size: 30, color: '#AAEEFF' },
      { word: '壮观', size: 28, color: '#6A9EED' },
      { word: '感动', size: 26, color: '#7ABEF5' },
      { word: '美丽', size: 24, color: '#8ACEF9' },
      { word: '精致', size: 22, color: '#9ADEFD' },
      { word: '喜欢', size: 20, color: '#AAEEFF' },
      { word: '文化', size: 28, color: '#5A9EED' },
      { word: '艺术', size: 26, color: '#6AAEF1' },
      { word: '历史', size: 24, color: '#7ABEF5' },
      { word: '体验', size: 22, color: '#8ACEF9' },
    ],
    platformDimensionTrend: {
      '小红书': {
        content: [1200, 1350, 1500, 1680, 1850, 2100, 2350, 2600],
        design: [1100, 1250, 1400, 1550, 1700, 1900, 2100, 2300],
        interaction: [800, 900, 1000, 1100, 1250, 1400, 1550, 1700],
        activities: [600, 700, 800, 900, 1000, 1150, 1300, 1450],
        service: [900, 1000, 1100, 1200, 1350, 1500, 1650, 1800],
      },
      '微博': {
        content: [1000, 1100, 1250, 1400, 1550, 1700, 1850, 2000],
        design: [900, 1000, 1150, 1300, 1450, 1600, 1750, 1900],
        interaction: [700, 800, 900, 1000, 1100, 1250, 1400, 1550],
        activities: [500, 600, 700, 800, 900, 1000, 1100, 1200],
        service: [800, 900, 1000, 1100, 1200, 1350, 1500, 1650],
      },
      '抖音': {
        content: [800, 900, 1000, 1150, 1300, 1450, 1600, 1750],
        design: [750, 850, 950, 1100, 1250, 1400, 1550, 1700],
        interaction: [600, 700, 800, 900, 1000, 1150, 1300, 1450],
        activities: [400, 500, 600, 700, 800, 900, 1000, 1100],
        service: [700, 800, 900, 1000, 1100, 1250, 1400, 1550],
      },
      '视频号': {
        content: [600, 700, 800, 900, 1000, 1150, 1300, 1450],
        design: [550, 650, 750, 850, 950, 1100, 1250, 1400],
        interaction: [400, 500, 600, 700, 800, 900, 1000, 1150],
        activities: [300, 400, 500, 600, 700, 800, 900, 1000],
        service: [500, 600, 700, 800, 900, 1000, 1150, 1300],
      },
    },
  },
  content: {
    name: '内容',
    score: 8.8,
    positive: 88,
    neutral: 9,
    negative: 3,
    total: 38456,
    highlights: [
      { text: '展品质量高，文化价值突出', count: 2890 },
      { text: '历史脉络梳理清楚，知识性强', count: 2456 },
      { text: '展品选择精良，代表性强', count: 2123 },
      { text: '内容详实，信息量丰富', count: 1890 },
    ],
    weaknesses: [
      { text: '部分展品说明文字过多', count: 567 },
      { text: '专业术语较多，理解有难度', count: 456 },
      { text: '缺少互动体验环节', count: 389 },
    ],
    positiveWordCloud: [
      { word: '精美', size: 48, color: '#10B981' },
      { word: '震撼', size: 44, color: '#059669' },
      { word: '丰富', size: 40, color: '#34D399' },
      { word: '专业', size: 38, color: '#10B981' },
      { word: '详实', size: 36, color: '#059669' },
      { word: '珍贵', size: 34, color: '#34D399' },
      { word: '精良', size: 32, color: '#10B981' },
      { word: '深度', size: 30, color: '#059669' },
      { word: '文化', size: 28, color: '#34D399' },
      { word: '历史', size: 26, color: '#10B981' },
      { word: '价值', size: 24, color: '#059669' },
      { word: '推荐', size: 22, color: '#34D399' },
    ],
    negativeWordCloud: [
      { word: '太多', size: 46, color: '#EF4444' },
      { word: '难懂', size: 42, color: '#DC2626' },
      { word: '专业', size: 38, color: '#F87171' },
      { word: '枯燥', size: 36, color: '#EF4444' },
      { word: '冗长', size: 34, color: '#DC2626' },
      { word: '复杂', size: 32, color: '#F87171' },
      { word: '缺少', size: 30, color: '#EF4444' },
      { word: '互动', size: 28, color: '#DC2626' },
      { word: '单调', size: 26, color: '#F87171' },
      { word: '疲劳', size: 24, color: '#EF4444' },
    ],
    positiveSummary: '观众普遍认为展览内容质量上乘，展品选择精良且具有代表性。历史脉络梳理清晰，知识性强，能够让观众深入了解敦煌文化的历史背景和艺术价值。内容详实丰富，信息量充足，文化价值突出，是一次难得的文化盛宴。',
    negativeSummary: '部分观众反映展品说明文字过于冗长，专业术语较多，普通观众理解起来有一定难度。此外，展览缺少互动体验环节，内容呈现方式相对单一，长时间观看容易产生阅读疲劳，建议增加多媒体互动内容。',
  },
  design: {
    name: '设计',
    score: 8.9,
    positive: 89,
    neutral: 8,
    negative: 3,
    total: 42345,
    highlights: [
      { text: '灯光设计专业，突出展品细节', count: 2678 },
      { text: '布景还原度高，细节考究', count: 2345 },
      { text: '场景氛围营造到位，代入感强', count: 2123 },
      { text: '空间利用合理，动线流畅', count: 1890 },
    ],
    weaknesses: [
      { text: '部分区域光线稍暗', count: 678 },
      { text: '个别位置存在反光问题', count: 456 },
      { text: '部分装饰略显简单', count: 389 },
    ],
  },
  interaction: {
    name: '互动',
    score: 7.9,
    positive: 79,
    neutral: 16,
    negative: 5,
    total: 15678,
    highlights: [
      { text: '互动装置新颖有趣，参与度高', count: 2345 },
      { text: 'AR/VR体验效果好', count: 1890 },
      { text: '多媒体展示形式丰富', count: 1567 },
      { text: '互动体验增强了理解', count: 1234 },
    ],
    weaknesses: [
      { text: '互动项目排队时间较长', count: 1567 },
      { text: '部分设备操作不够直观', count: 1234 },
      { text: '互动区域数量偏少', count: 678 },
    ],
  },
  activities: {
    name: '活动',
    score: 8.3,
    positive: 83,
    neutral: 13,
    negative: 4,
    total: 12345,
    highlights: [
      { text: '专家讲座内容丰富，专业性强', count: 2123 },
      { text: '工作坊活动形式多样', count: 1789 },
      { text: '导览服务专业热情', count: 1567 },
      { text: '活动安排合理，内容充实', count: 1234 },
    ],
    weaknesses: [
      { text: '活动时间安排可以更灵活', count: 890 },
      { text: '部分活动需要额外付费', count: 456 },
      { text: '活动名额有限，预约困难', count: 389 },
    ],
  },
  service: {
    name: '服务',
    score: 8.5,
    positive: 85,
    neutral: 12,
    negative: 3,
    total: 18234,
    highlights: [
      { text: '工作人员服务态度好，专业热情', count: 2456 },
      { text: '场馆设施完善，环境舒适', count: 2123 },
      { text: '预约系统便捷，流程顺畅', count: 1890 },
      { text: '安全措施到位，秩序良好', count: 1567 },
    ],
    weaknesses: [
      { text: '高峰期人流管理有待改善', count: 789 },
      { text: '休息区座位不足', count: 567 },
      { text: '部分指引标识不够清晰', count: 456 },
    ],
  },
};

export const mockAudienceInsights = [
  { type: '观众', count: 28456, percentage: 62.3, avgEngagement: 234 },
  { type: 'KOL', count: 4567, percentage: 10.0, avgEngagement: 5678 },
  { type: '官方', count: 2345, percentage: 5.1, avgEngagement: 8901 },
  { type: '专家', count: 10310, percentage: 22.6, avgEngagement: 1234 },
];

export const mockContents = [
  {
    id: '1',
    platform: '小红书',
    author: '艺术爱好者小王',
    authorType: '观众',
    content: '敦煌艺术特展真的太震撼了！灯光设计特别用心,每一幅壁画都被照得栩栩如生。布景还原了洞窟的感觉,仿佛置身于千年前的敦煌。说明牌内容详实,让我对佛教艺术有了更深的理解。强烈推荐大家来看！',
    images: [
      'https://public.readdy.ai/ai/img_res/3d3fb052a7b2e615041e4e10b33cfc3e.jpg',
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20detailed%20mural%20close%20up%20colorful%20buddhist%20paintings%20ancient%20art%20warm%20lighting%20professional%20photography&width=400&height=300&seq=content1img2&orientation=landscape',
    ],
    likes: 89,
    comments: 23,
    collects: 45,
    sentiment: 'positive',
    publishTime: '2024-02-15 14:23',
    relevanceScore: 95,
    sentimentScore: 92,
    influenceScore: 78,
  },
  {
    id: '2',
    platform: '微博',
    author: '博物馆观察员',
    authorType: 'KOL',
    content: '从专业角度来看,这次敦煌艺术特展的策展水平相当高。灯光运用恰到好处,既保护了展品又营造了沉浸式体验。布景设计考究,场景氛围营造得很到位。唯一建议是说明牌字体可以再大一些,方便老年观众阅读。总体评分9/10。',
    images: [
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20wide%20angle%20view%20exhibition%20hall%20with%20visitors%20atmospheric%20lighting%20professional%20setup%20warm%20tones&width=400&height=300&seq=content2img1&orientation=landscape',
    ],
    likes: 67,
    comments: 56,
    shares: 45,
    sentiment: 'positive',
    publishTime: '2024-02-14 10:15',
    relevanceScore: 98,
    sentimentScore: 88,
    influenceScore: 92,
  },
  {
    id: '9',
    platform: '微博',
    author: '敦煌艺术博物馆官方',
    authorType: '官方',
    content: '【敦煌艺术特展】正式开幕！本次展览汇集了敦煌莫高窟精品文物复制品，通过现代科技手段再现千年艺术瑰宝。展期：2024年1月15日-3月15日，欢迎广大艺术爱好者前来参观。开放时间：周二至周日 9:00-17:00（周一闭馆）。',
    images: [
      'https://readdy.ai/api/search-image?query=official%20museum%20announcement%20poster%20dunhuang%20art%20exhibition%20grand%20opening%20ceremony%20professional%20photography%20warm%20elegant%20lighting%20cultural%20heritage&width=400&height=300&seq=content9img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20official%20opening%20ceremony%20ribbon%20cutting%20cultural%20event%20professional%20photography%20warm%20tones&width=400&height=300&seq=content9img2&orientation=landscape',
    ],
    likes: 34,
    comments: 89,
    shares: 56,
    sentiment: 'positive',
    publishTime: '2024-01-15 09:00',
    relevanceScore: 100,
    sentimentScore: 85,
    influenceScore: 98,
  },
  {
    id: '10',
    platform: '小红书',
    author: '市文化艺术中心',
    authorType: '官方',
    content: '敦煌艺术特展开展一周，已接待观众超过5000人次！感谢大家的热情支持。为了给大家更好的观展体验，我们增加了周末场次，并优化了参观路线。温馨提示：建议提前在官方平台预约，避免现场排队等候。',
    images: [
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20crowded%20visitors%20enjoying%20exhibition%20official%20announcement%20warm%20lighting%20professional%20photography&width=400&height=300&seq=content10img1&orientation=landscape',
    ],
    likes: 78,
    comments: 45,
    collects: 67,
    sentiment: 'positive',
    publishTime: '2024-01-22 16:30',
    relevanceScore: 96,
    sentimentScore: 90,
    influenceScore: 88,
  },
  {
    id: '11',
    platform: '视频号',
    author: '敦煌艺术博物馆',
    authorType: '官方',
    content: '【专家导览】本周六下午2点，特邀敦煌研究院专家为大家讲解敦煌壁画的艺术价值与历史背景。名额有限，扫码预约！让我们一起走进千年敦煌，感受丝绸之路的文化魅力。',
    video: 'https://readdy.ai/api/search-image?query=museum%20official%20video%20announcement%20expert%20guide%20tour%20dunhuang%20art%20exhibition%20professional%20lighting%20educational%20content%20warm%20atmosphere&width=400&height=300&seq=content11video&orientation=landscape',
    likes: 45,
    comments: 67,
    favorites: 23,
    shares: 89,
    sentiment: 'positive',
    publishTime: '2024-02-05 10:00',
    relevanceScore: 94,
    sentimentScore: 87,
    influenceScore: 85,
  },
  {
    id: '3',
    platform: '抖音',
    author: '文化探索者',
    authorType: '观众',
    content: '周末打卡敦煌艺术特展！氛围感拉满,每个角落都很出片。就是人有点多,建议工作日来。展板内容很丰富,可以学到很多知识。',
    video: 'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20video%20thumbnail%20people%20viewing%20exhibition%20atmospheric%20lighting%20warm%20colors%20professional%20photography&width=400&height=300&seq=content3video&orientation=landscape',
    likes: 92,
    comments: 34,
    collects: 78,
    shares: 29,
    sentiment: 'positive',
    publishTime: '2024-02-13 16:45',
    relevanceScore: 88,
    sentimentScore: 82,
    influenceScore: 72,
  },
  {
    id: '4',
    platform: '视频号',
    author: '艺术史研究者',
    authorType: '专家',
    content: '敦煌艺术特展的学术价值很高,展品选择精良,时间线清晰。灯光设计符合文物保护要求,同时兼顾了观赏性。建议增加更多互动体验环节,让观众更深入了解敦煌文化的历史背景和艺术价值。',
    video: 'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20expert%20commentary%20video%20thumbnail%20professional%20lighting%20educational%20content%20warm%20tones&width=400&height=300&seq=content4video&orientation=landscape',
    likes: 54,
    comments: 45,
    favorites: 67,
    shares: 23,
    sentiment: 'positive',
    publishTime: '2024-02-12 09:30',
    relevanceScore: 97,
    sentimentScore: 86,
    influenceScore: 81,
  },
  {
    id: '5',
    platform: '小红书',
    author: '摄影师阿杰',
    authorType: 'KOL',
    content: '作为摄影师,我对这次展览的灯光设计印象深刻。每一处光影都经过精心设计,既突出了展品细节,又营造了神秘的氛围。布景和场景设计也很用心,非常适合拍照。唯一遗憾是部分区域光线稍暗,手机拍摄有点困难。',
    images: [
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20professional%20photography%20dramatic%20lighting%20artistic%20composition%20warm%20tones%20atmospheric%20mood&width=400&height=300&seq=content5img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20detail%20shot%20lighting%20design%20artistic%20photography%20warm%20colors%20professional%20quality&width=400&height=300&seq=content5img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20ambient%20lighting%20scene%20design%20atmospheric%20photography%20warm%20tones%20professional%20setup&width=400&height=300&seq=content5img3&orientation=landscape',
    ],
    likes: 89,
    comments: 89,
    collects: 92,
    sentiment: 'positive',
    publishTime: '2024-02-11 18:20',
    relevanceScore: 92,
    sentimentScore: 84,
    influenceScore: 89,
  },
  {
    id: '6',
    platform: '微博',
    author: '历史文化爱好者',
    authorType: '观众',
    content: '敦煌艺术特展值得一看,展品很丰富。灯光效果不错,但是周末人太多了,观展体验打了折扣。建议提前预约,选择工作日参观会更好。',
    images: [
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20crowded%20exhibition%20hall%20visitors%20viewing%20artworks%20warm%20lighting%20professional%20photography&width=400&height=300&seq=content6img1&orientation=landscape',
    ],
    likes: 34,
    comments: 15,
    shares: 8,
    sentiment: 'neutral',
    publishTime: '2024-02-10 15:30',
    relevanceScore: 85,
    sentimentScore: 65,
    influenceScore: 58,
  },
  {
    id: '7',
    platform: '抖音',
    author: '旅行博主小美',
    authorType: 'KOL',
    content: '敦煌艺术特展打卡！整体氛围很棒,灯光布景都很用心。拍了好多美照,分享给大家。记得带相机哦！',
    video: 'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20vlog%20style%20video%20thumbnail%20young%20woman%20taking%20photos%20beautiful%20lighting%20warm%20atmosphere&width=400&height=300&seq=content7video&orientation=landscape',
    likes: 93,
    comments: 78,
    collects: 85,
    shares: 34,
    sentiment: 'positive',
    publishTime: '2024-02-09 19:45',
    relevanceScore: 82,
    sentimentScore: 88,
    influenceScore: 86,
  },
  {
    id: '8',
    platform: '视频号',
    author: '文博讲解员',
    authorType: '专家',
    content: '带大家深度解读敦煌艺术特展。这次展览的策展理念很先进,通过灯光、布景、多媒体等手段,让观众能够更直观地感受敦煌艺术的魅力。',
    video: 'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20educational%20video%20thumbnail%20guide%20explaining%20artworks%20professional%20lighting%20warm%20tones&width=400&height=300&seq=content8video&orientation=landscape',
    likes: 67,
    comments: 67,
    favorites: 89,
    shares: 45,
    sentiment: 'positive',
    publishTime: '2024-02-08 11:20',
    relevanceScore: 96,
    sentimentScore: 89,
    influenceScore: 83,
  },
  {
    id: '12',
    platform: '小红书',
    author: '失望的观众',
    authorType: '观众',
    content: '说实话有点失望。票价不便宜，但展品数量比想象中少很多。灯光确实不错，但说明牌的字太小了，老人根本看不清。而且工作人员态度一般，问个路都爱答不理的。不太推荐。',
    images: [
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20disappointed%20visitor%20empty%20exhibition%20hall%20dim%20lighting%20sparse%20displays%20professional%20photography&width=400&height=300&seq=content12img1&orientation=landscape',
    ],
    likes: 23,
    comments: 45,
    collects: 8,
    sentiment: 'negative',
    publishTime: '2024-02-14 20:15',
    relevanceScore: 78,
    sentimentScore: 28,
    influenceScore: 52,
  },
  {
    id: '13',
    platform: '微博',
    author: '吐槽小能手',
    authorType: '观众',
    content: '敦煌艺术特展体验很差！周末去的，排队1小时才进去，里面人挤人根本看不了。空调不给力，热得要命。最气人的是休息区座位太少，老人孩子都没地方坐。这管理水平真的不行。',
    images: [
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20overcrowded%20visitors%20long%20queue%20waiting%20uncomfortable%20environment%20professional%20photography&width=400&height=300&seq=content13img1&orientation=landscape',
    ],
    likes: 67,
    comments: 89,
    shares: 34,
    sentiment: 'negative',
    publishTime: '2024-02-13 21:30',
    relevanceScore: 82,
    sentimentScore: 18,
    influenceScore: 68,
  },
  {
    id: '14',
    platform: '抖音',
    author: '理性评价者',
    authorType: '观众',
    content: '敦煌艺术特展不值这个价。展品都是复制品，没有真品。互动区域就两个，还要额外收费。说明牌内容太专业，普通人看不懂。感觉性价比很低，不如去看其他展览。',
    video: 'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20disappointed%20review%20video%20thumbnail%20empty%20interactive%20area%20expensive%20tickets%20professional%20photography&width=400&height=300&seq=content14video&orientation=landscape',
    likes: 45,
    comments: 67,
    collects: 12,
    shares: 23,
    sentiment: 'negative',
    publishTime: '2024-02-12 17:45',
    relevanceScore: 85,
    sentimentScore: 22,
    influenceScore: 61,
  },
  {
    id: '15',
    platform: '视频号',
    author: '文化批评家',
    authorType: '专家',
    content: '从专业角度看，这次敦煌艺术特展存在不少问题。首先，展品陈列缺乏逻辑性，时间线混乱。其次，灯光虽然漂亮但过于注重视觉效果，忽略了文物保护的基本要求。最后，缺少深度的学术解读，流于表面。建议主办方认真改进。',
    video: 'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20expert%20criticism%20video%20thumbnail%20poor%20lighting%20arrangement%20messy%20display%20professional%20photography&width=400&height=300&seq=content15video&orientation=landscape',
    likes: 34,
    comments: 78,
    favorites: 23,
    shares: 45,
    sentiment: 'negative',
    publishTime: '2024-02-11 14:20',
    relevanceScore: 92,
    sentimentScore: 25,
    influenceScore: 75,
  },
  {
    id: '16',
    platform: '小红书',
    author: '普通游客小张',
    authorType: '观众',
    content: '不推荐！展览动线设计有问题，经常走回头路。指示牌不清楚，找个洗手间都要问好几次。而且现场秩序管理混乱，有人大声喧哗也没人管。花了这么多钱，体验太差了。',
    images: [
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20confusing%20layout%20poor%20signage%20chaotic%20crowd%20management%20professional%20photography&width=400&height=300&seq=content16img1&orientation=landscape',
    ],
    likes: 56,
    comments: 34,
    collects: 9,
    sentiment: 'negative',
    publishTime: '2024-02-10 19:50',
    relevanceScore: 80,
    sentimentScore: 20,
    influenceScore: 55,
  },
  {
    id: '17',
    platform: '微博',
    author: '资深观展者',
    authorType: 'KOL',
    content: '作为经常看展的人，这次敦煌艺术特展让我很失望。布景粗糙，很多地方能看出是临时搭建的。说明牌错别字不少，专业性存疑。互动设备经常故障，工作人员也不及时维修。整体感觉就是赶工出来的，缺乏诚意。',
    images: [
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20poor%20quality%20setup%20temporary%20construction%20rough%20display%20broken%20equipment%20professional%20photography&width=400&height=300&seq=content17img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20malfunctioning%20interactive%20device%20out%20of%20order%20sign%20poor%20maintenance%20professional%20photography&width=400&height=300&seq=content17img2&orientation=landscape',
    ],
    likes: 89,
    comments: 123,
    shares: 67,
    sentiment: 'negative',
    publishTime: '2024-02-09 16:30',
    relevanceScore: 88,
    sentimentScore: 15,
    influenceScore: 82,
  },
  {
    id: '18',
    platform: '抖音',
    author: '带娃妈妈',
    authorType: '观众',
    content: '带孩子去看的，结果很不愉快。儿童区域太小，设施也很少。说明牌全是文字，孩子根本看不懂。工作人员还嫌孩子吵，态度很差。母婴室也没有，换尿布都没地方。真的不适合带小孩来。',
    video: 'https://readdy.ai/api/search-image?query=museum%20exhibition%20dunhuang%20art%20unfriendly%20for%20children%20small%20kids%20area%20limited%20facilities%20unhappy%20family%20professional%20photography&width=400&height=300&seq=content18video&orientation=landscape',
    likes: 78,
    comments: 56,
    collects: 23,
    shares: 34,
    sentiment: 'negative',
    publishTime: '2024-02-08 15:40',
    relevanceScore: 75,
    sentimentScore: 18,
    influenceScore: 64,
  },
];
